import { useState, useMemo } from "react";

export function useCategoryFilters(categories) {
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [sortBy, setSortBy] = useState("name");

  const filteredCategories = useMemo(() => {
    return categories
      .filter((c) => {
        const matchesSearch =
          c.name && c.name.toLowerCase().includes(searchQuery.toLowerCase());
        const matchesStatus =
          statusFilter === "all" ||
          (statusFilter === "active" && c.status === "active") ||
          (statusFilter === "disabled" && c.status === "disabled");
        return matchesSearch && matchesStatus;
      })
      .sort((a, b) => {
        if (sortBy === "name") return a.name.localeCompare(b.name);
        if (sortBy === "date") return b.id - a.id;
        if (sortBy === "products") return b.productsCount - a.productsCount;
        return 0;
      });
  }, [categories, searchQuery, statusFilter, sortBy]);

  return {
    searchQuery,
    setSearchQuery,
    statusFilter,
    setStatusFilter,
    sortBy,
    setSortBy,
    filteredCategories,
  };
}
